import { cn } from '../../utils/cn';
import { Icon } from '../Icon';

type BreadcrumbSeparatorProps = {
  className?: string;
}

export const BreadcrumbSeparator = ( { className }: BreadcrumbSeparatorProps ) => {

  return (
    <li
      role={ 'presentation' }
      aria-hidden={ true }
      className={ cn( 'first:block hidden md:block md:first:hidden', className ) }
    >
      <Icon
        className={ 'text-xl' }
        name={ 'chevron-right' } />
    </li>
  )
}
BreadcrumbSeparator.displayName = 'BreadcrumbSeparator';
